import { render } from "./Index.vue?vue&type=template&id=2f659940&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f659940"]])

export default __exports__